import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  GrowlType,
  AlertService,
} from 'app/infrastructure/services/alert.service';
import { LoaderService } from 'app/infrastructure/services/loader.service';
import { Translator } from 'angular-translator';
import { ProductReportService } from 'app/infrastructure/services/productreport.service';
import {
  ProductReport,
  ProductReportCategories,
  ProductReportStandardDictionary,
} from 'app/infrastructure/model/classes/productReport.class';
import { File64 } from 'app/helpers/components/sxFileImport/file64.interf';
import { ProductReportTypes } from 'app/infrastructure/model/enum/productReportTypes.enum';
import { AzureFileManagerService } from 'app/infrastructure/services/azureFileManager.service';
import { debug } from 'util';

@Component({
  selector: 'sx-detail-productreport',
  templateUrl: './detail.productreport.component.html',
  styleUrls: ['./detail.productreport.component.css'],
})
export class DetailProductReportComponent implements OnInit {
  report: ProductReport;
  reportCategories: ProductReportCategories[] = [];
  reportStandardDictionary: ProductReportStandardDictionary[] = [];
  codSistema: string;
  codBusiness: string;
  codProduct: string;
  codProducReport: string;
  seccionActual: string;
  ruleName: string;
  file: File64 = null;
  completeness = 0;
  isNew = true;
  checkeandCodigo = false;
  errorCodigo = null;
  types = [
    ProductReportTypes.HtmlDependet,
    ProductReportTypes.RuleDependent,
    ProductReportTypes.PDFDependet,
  ];
  supported: string[] = ['.docx', '.pdf', '.html'];

  constructor(
    public loaderService: LoaderService,
    private alertService: AlertService,
    private azureService: AzureFileManagerService,
    private productReportService: ProductReportService,
    private router: Router,
    private aRoute: ActivatedRoute,
    private translator: Translator
  ) {}

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codSistema = params['codsistema'];
      this.codBusiness = params['codnegocio'];
      this.codProduct = params['codproducto'];
      this.codProducReport = params['productReportCode'];
      this.isNew = false;

      if (!this.codSistema) {
        this.getStandardDictionary();
        this.getCategories();
      }

      if (this.codProducReport === 'nuevo') {
        this.isNew = true;
        this.report = new ProductReport();
        return;
      }

      this.initalizeElement();

    });
  }

  initalizeElement()
  {
    this.productReportService.get(this.codProducReport).subscribe((data) => {
      if (!data) {
        return this.router.navigateByUrl('/soc/404');
      }
      this.report = data;
      this.inicializarCampos(data);
    });
  }

  getStandardDictionary() {
    this.productReportService
      .getStandardDictionary()
      .subscribe((res) => (this.reportStandardDictionary = res));
  }

  getCategories() {
    this.productReportService
      .getCategories()
      .subscribe((res) => (this.reportCategories = res));
  }

  isValidForm(): boolean {
    return (
      this.report.configurationType !== null &&
      this.report.productReportCode !== undefined &&
      this.report.productReportCode.length > 0 &&
      this.report.description !== undefined &&
      this.report.description.length > 0 &&
      this.report.configurationType !== undefined &&
      (this.codSistema ? true : (this.report.category.id !== null && this.report.standardDictionary.id !== null) )
    );
  }
  createReport() {
    if (this.isNew) {
      this.report.systemCode = this.codSistema;
      this.report.productCode = this.codProduct;
      this.report.businessCode = this.codBusiness;
      this.productReportService.create(this.report).then((report) => {
        this.isNew = false;
        this.alertService.showGrowl({
          type: GrowlType.SUCCESS,
          body: 'REPORT_CREADO_CORRECTAMENTE',
        });

        this.router.navigate(['../', report.id], {
          relativeTo: this.aRoute.parent,
        });
      });
    } else {
      this.productReportService.edit(this.report).then((data) => {
        this.inicializarCampos(data);
        this.alertService.showGrowl({
          type: GrowlType.SUCCESS,
          body: 'EDITADO_CORRECTAMENTE',
        });
      });
    }
  }

  editarDescripcion(nuevoTexto) {
    this.report.description = nuevoTexto;
  }
  editarDescripcionExt(nuevoTexto) {
    this.report.descriptionEXT = nuevoTexto;
  }
  editarImagen(nuevaImagen) {
    this.report.thumbnail = nuevaImagen.imagenBase64;
  }
  changeCategory(id) {
    let cat = this.reportCategories.find((x) => x.id === id);
    this.report.category === cat;
  }
  changeStandardDictionary(id) {
    let std = this.reportStandardDictionary.find((x) => x.id === id);
    this.report.standardDictionary === std;
  }

  private inicializarCampos(data) {
    if (data) {
      this.report.fechaActualizacion = data.fechaActualizacion;
      this.report.modificado = data.modificado;
      this.report.urlImage = data.urlImage;

      if(this.codSistema){
          this.report.systemCode = this.codSistema;
      }
      if(this.codBusiness){
        this.report.businessCode = this.codBusiness;
      }
      if(this.codProduct){
        this.report.productCode = this.codProduct;
      }
    }
  }

  back() {
    this.router.navigate(['../'], { relativeTo: this.aRoute.parent });
  }

  disable() {
    this.productReportService.delete(this.report.id).then((success) => {
      if (success) {
        this.alertService.showGrowl({
          type: GrowlType.SUCCESS,
          body: 'REPORT_CREADO_CORRECTAMENTE',
        });
        this.back();
      }
    });
  }
  isRuleType() {
    return this.report.configurationType === ProductReportTypes.RuleDependent;
  }
  isTemplateType() {
    return (
      this.report.configurationType === ProductReportTypes.HtmlDependet ||
      this.report.configurationType === ProductReportTypes.PDFDependet
    );
  }
  createRule() {
    this.productReportService
      .createRule(this.report, this.ruleName)
      .then((ruleId) => {
        this.router.navigate(['./confRegla', ruleId], {
          relativeTo: this.aRoute,
        });
      });
  }
  mappingRule() {
    if (this.codSistema)
      this.router.navigate(['./confRegla', this.report.boundRuleId], {
        relativeTo: this.aRoute,
      });
  }
  onRuleActiveChange(ruleId) {
    this.report.rules.forEach((r) => {
      r.active = r.id === ruleId;
    });
  }
  editRule(ruleId) {
    this.router.navigate(['./confRegla', ruleId], {
      relativeTo: this.aRoute,
    });
  }
  deleteRule(ruleId) {
    this.productReportService
      .deleteRule(this.report.id, ruleId)
      .then((success) => {
        if (success) {
          this.alertService.showGrowl({
            type: GrowlType.SUCCESS,
            body: 'PRODUCT_REPORT_RULE_DELETE_SUCCESS',
          });
          this.report.rules = this.report.rules.filter((r) => r.id !== ruleId);
        }
      });
  }
  selectedTemplate(template: File64) {
    this.file = template;
  }
  scanTemplate() {
    if (this.file !== null) {
      let fileToUpload: any;

      fileToUpload = {
        folder: this.report.id,
        fileName: this.file.fileName,
        file: this.file.fileData,
      };

      this.azureService
        .uploadProductReportFile(fileToUpload)
        .then((attributes) => {
          this.initalizeElement();
        });
    }
  }
  isValidFile(): boolean {
    const extension =
      this.file != null
        ? this.file.fileName
            .split('.')
            .pop()
            .replace(/^/, '.')
        : null;
    return this.supported.some((validExt) => validExt === extension);
  }
  downladTemplate() {
    this.azureService
      .downloadTemplate(this.codProducReport)
      .subscribe((data) => {
        window.open(data.toString(), '_blank');
        this.alertService.showGrowl({
          type: GrowlType.SUCCESS,
          body: 'EXPORTACION_EXITOSA',
        });
      });
  }
  deleteAttribute(attributeId) {
    this.productReportService.deleteAttribute(attributeId).then((success) => {
      if (success) {
        this.alertService.showGrowl({
          type: GrowlType.SUCCESS,
          body: 'PRODUCT_REPORT_ATTRIBUTE_DELETE_SUCCESS',
        });
        this.report.mappingAttributes = this.report.mappingAttributes.filter(
          (a) => a.id !== attributeId
        );
      }
    });
  }
  navigateToMapping(atributeId) {
    this.router.navigate([`./mapping/${atributeId}`], {
      relativeTo: this.aRoute,
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/productReport/deatils/detail.productreport.component.ts